import { dew as _configurationsDew } from "../../configurations";
import { dew as _chronoDew } from "../../chrono";
import { dew as _NLMergeDateRangeRefinerDew } from "./refiners/NLMergeDateRangeRefiner";
import { dew as _NLMergeDateTimeRefinerDew } from "./refiners/NLMergeDateTimeRefiner";
import { dew as _NLCasualDateParserDew } from "./parsers/NLCasualDateParser";
import { dew as _NLCasualTimeParserDew } from "./parsers/NLCasualTimeParser";
import { dew as _SlashDateFormatParserDew } from "../../common/parsers/SlashDateFormatParser";
import { dew as _NLTimeUnitWithinFormatParserDew } from "./parsers/NLTimeUnitWithinFormatParser";
import { dew as _NLWeekdayParserDew } from "./parsers/NLWeekdayParser";
import { dew as _NLMonthNameMiddleEndianParserDew } from "./parsers/NLMonthNameMiddleEndianParser";
import { dew as _NLMonthNameParserDew } from "./parsers/NLMonthNameParser";
import { dew as _NLSlashMonthFormatParserDew } from "./parsers/NLSlashMonthFormatParser";
import { dew as _NLTimeExpressionParserDew } from "./parsers/NLTimeExpressionParser";
import { dew as _NLCasualYearMonthDayParserDew } from "./parsers/NLCasualYearMonthDayParser";
import { dew as _NLCasualDateTimeParserDew } from "./parsers/NLCasualDateTimeParser";
import { dew as _NLTimeUnitCasualRelativeFormatParserDew } from "./parsers/NLTimeUnitCasualRelativeFormatParser";
import { dew as _NLRelativeDateFormatParserDew } from "./parsers/NLRelativeDateFormatParser";
import { dew as _NLTimeUnitAgoFormatParserDew } from "./parsers/NLTimeUnitAgoFormatParser";
import { dew as _NLTimeUnitLaterFormatParserDew } from "./parsers/NLTimeUnitLaterFormatParser";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createConfiguration = exports.createCasualConfiguration = exports.parseDate = exports.parse = exports.strict = exports.casual = void 0;
  const configurations_1 = _configurationsDew();
  const chrono_1 = _chronoDew();
  const NLMergeDateRangeRefiner_1 = __importDefault(_NLMergeDateRangeRefinerDew());
  const NLMergeDateTimeRefiner_1 = __importDefault(_NLMergeDateTimeRefinerDew());
  const NLCasualDateParser_1 = __importDefault(_NLCasualDateParserDew());
  const NLCasualTimeParser_1 = __importDefault(_NLCasualTimeParserDew());
  const SlashDateFormatParser_1 = __importDefault(_SlashDateFormatParserDew());
  const NLTimeUnitWithinFormatParser_1 = __importDefault(_NLTimeUnitWithinFormatParserDew());
  const NLWeekdayParser_1 = __importDefault(_NLWeekdayParserDew());
  const NLMonthNameMiddleEndianParser_1 = __importDefault(_NLMonthNameMiddleEndianParserDew());
  const NLMonthNameParser_1 = __importDefault(_NLMonthNameParserDew());
  const NLSlashMonthFormatParser_1 = __importDefault(_NLSlashMonthFormatParserDew());
  const NLTimeExpressionParser_1 = __importDefault(_NLTimeExpressionParserDew());
  const NLCasualYearMonthDayParser_1 = __importDefault(_NLCasualYearMonthDayParserDew());
  const NLCasualDateTimeParser_1 = __importDefault(_NLCasualDateTimeParserDew());
  const NLTimeUnitCasualRelativeFormatParser_1 = __importDefault(_NLTimeUnitCasualRelativeFormatParserDew());
  const NLRelativeDateFormatParser_1 = __importDefault(_NLRelativeDateFormatParserDew());
  const NLTimeUnitAgoFormatParser_1 = __importDefault(_NLTimeUnitAgoFormatParserDew());
  const NLTimeUnitLaterFormatParser_1 = __importDefault(_NLTimeUnitLaterFormatParserDew());
  exports.casual = new chrono_1.Chrono(createCasualConfiguration());
  exports.strict = new chrono_1.Chrono(createConfiguration(true));
  function parse(text, ref, option) {
    return exports.casual.parse(text, ref, option);
  }
  exports.parse = parse;
  function parseDate(text, ref, option) {
    return exports.casual.parseDate(text, ref, option);
  }
  exports.parseDate = parseDate;
  function createCasualConfiguration(littleEndian = true) {
    const option = createConfiguration(false, littleEndian);
    option.parsers.unshift(new NLCasualDateParser_1.default());
    option.parsers.unshift(new NLCasualTimeParser_1.default());
    option.parsers.unshift(new NLCasualDateTimeParser_1.default());
    option.parsers.unshift(new NLMonthNameParser_1.default());
    option.parsers.unshift(new NLRelativeDateFormatParser_1.default());
    option.parsers.unshift(new NLTimeUnitCasualRelativeFormatParser_1.default());
    return option;
  }
  exports.createCasualConfiguration = createCasualConfiguration;
  function createConfiguration(strictMode = true, littleEndian = true) {
    return configurations_1.includeCommonConfiguration({
      parsers: [new SlashDateFormatParser_1.default(littleEndian), new NLTimeUnitWithinFormatParser_1.default(), new NLMonthNameMiddleEndianParser_1.default(), new NLMonthNameParser_1.default(), new NLWeekdayParser_1.default(), new NLCasualYearMonthDayParser_1.default(), new NLSlashMonthFormatParser_1.default(), new NLTimeExpressionParser_1.default(strictMode), new NLTimeUnitAgoFormatParser_1.default(strictMode), new NLTimeUnitLaterFormatParser_1.default(strictMode)],
      refiners: [new NLMergeDateTimeRefiner_1.default(), new NLMergeDateRangeRefiner_1.default()]
    }, strictMode);
  }
  exports.createConfiguration = createConfiguration;
  //# sourceMappingURL=index.js.map
  return exports;
}